/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { IncomingContent } from '@/data/types/IncomingContent';
import { Layout } from '@/data/types/Layout';
import { getContentItemForSlot } from '@/data/utils/getContentItemForSlot';

export const getBrandCategoryLayoutContainer = (props: IncomingContent): Layout => ({
	name: 'BrandCategoryLayout',
	slots: {
		header: [{ name: 'Header', id: 'header' }],
		first: getContentItemForSlot(props, 'first'),
		second: getContentItemForSlot(props, 'second'),
		third: getContentItemForSlot(props, 'third'),
		fourth: getContentItemForSlot(props, 'fourth'),
		fifth: getContentItemForSlot(props, 'fifth'),
		six: getContentItemForSlot(props, 'six'),
		seven: getContentItemForSlot(props, 'seven'),
		eight: getContentItemForSlot(props, 'eight'),
		nine: getContentItemForSlot(props, 'nine'),
		ten: getContentItemForSlot(props, 'ten'),
		eleven: getContentItemForSlot(props, 'eleven'),
		twelve: getContentItemForSlot(props, 'twelve'),
		thirteen: getContentItemForSlot(props, 'thirteen'),
		fourteen: getContentItemForSlot(props, 'fourteen'),
		fifteen: getContentItemForSlot(props, 'fifteen'),
		sixteen: getContentItemForSlot(props, 'sixteen'),
		seventeen: getContentItemForSlot(props, 'seventeen'),
		eighteen: getContentItemForSlot(props, 'eighteen'),
		nineteen: getContentItemForSlot(props, 'nineteen'),
		twenty: getContentItemForSlot(props, 'twenty'),
		twentyone: getContentItemForSlot(props, 'twentyone'),
		twentytwo: getContentItemForSlot(props, 'twentytwo'),
		twentythree: getContentItemForSlot(props, 'twentythree'),
		twentyfour: getContentItemForSlot(props, 'twentyfour'),
		twentyfive: getContentItemForSlot(props, 'twentyfive'),
		twentysix: getContentItemForSlot(props, 'twentysix'),
		twentyseven: getContentItemForSlot(props, 'twentyseven'),
		twentyeight: getContentItemForSlot(props, 'twentyeight'),
		twentynine: getContentItemForSlot(props, 'twentynine'),
		thirty: getContentItemForSlot(props, 'thirty'),
		footer: [{ name: 'Footer', id: 'footer' }],
	},
});
